import '../styles/custom.scss';
import './theme.js';

import DynamicMediaWithOverlay from './sections/DynamicMediaWithOverlay';
import DynamicVideo from './sections/DynamicVideo';
// Import sections
import Sections from '@pixelunion/shopify-sections-manager';
// Plugins
import rimg from '@pixelunion/rimg-shopify';

rimg.init();


const sections = new Sections();
sections.register('dynamic-video', (section) => new DynamicVideo(section));
sections.register(
  'dynamic-media-with-overlay',
  (section) => new DynamicMediaWithOverlay(section)
);
